function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = _ref => {
  let {
    size,
    title,
    desc,
    titleId,
    descId,
    ...props
  } = _ref;
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 14.95L16.3 13.5a4.78 4.78 0 00.525-1.2c.117-.417.175-.85.175-1.3h2c0 .733-.108 1.43-.325 2.088a7.335 7.335 0 01-.925 1.862zm-2.95-3L9 6.15V5c0-.833.292-1.542.875-2.125A2.893 2.893 0 0112 2c.833 0 1.542.292 2.125.875S15 4.167 15 5v6c0 .183-.02.35-.063.5-.041.15-.087.3-.137.45zM11 21v-3.1c-1.733-.233-3.167-1.004-4.3-2.312C5.567 14.279 5 12.75 5 11h2c0 1.383.487 2.563 1.462 3.537C9.437 15.512 10.617 16 12 16a4.919 4.919 0 003-1l1.425 1.425a7.468 7.468 0 01-1.588.962A6.463 6.463 0 0113 17.9V21h-2zm8.8 1.6L1.4 4.2l1.4-1.4 18.4 18.4-1.4 1.4z"
  }));
};
const SvgMicOff = styled(BaseComponent).withConfig({
  displayName: "MicOff__SvgMicOff",
  componentId: "sc-1vj0k15-0"
})(["outline:none;"]);
SvgMicOff.isIcon = true;
SvgMicOff.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgMicOff;